import { useTranslation } from "react-i18next";
import { Checkbox, Select, MenuItem, ListSubheader, ListItemText, FormControl, InputLabel } from '@mui/material';

import {TRENDS_KEYS, KEY_TO_TEXT} from '../../../util/keys';

const KeySelector = (props) => {

    const { keys, onChange, onClose } = props;

    const { t } = useTranslation();

    const switchKey = (key, value) => {
        if (value) {
            onChange(
                [...keys, key]
            )
        } else {
            onChange(
                keys.filter((k)=>k!==key)
            )
        }
    }

    return (
        <FormControl sx={{ minWidth: 120 }} size="small">
            <Select
                value={[""]}
                multiple
                renderValue={(value) => t("Data")}
                onClose={() => onClose()}
            >
                {
                    TRENDS_KEYS.map((key)=>
                        <MenuItem key={key}>
                            <Checkbox
                                checked={keys.includes(key)}
                                onChange={(event) => switchKey(key , event.target.checked)}
                            /><ListItemText primary={t(KEY_TO_TEXT[key])} />
                        </MenuItem>
                    )
                }
            </Select>
        </FormControl>

    )

}

export default KeySelector;